import { getInvoiceRole, isDepositInvoiceRole } from './invoiceDeposits';

const money = (value) => Math.round((Number(value) || 0) * 100) / 100;

export const getIssuedPaymentSummary = (invoice = {}) => {
  const summary = invoice?.paymentSummary || {};
  return {
    priorDepositPaid: money(Math.max(0, Number(summary.priorDepositPaid) || 0)),
    priorOtherPayments: money(Math.max(0, Number(summary.priorOtherPayments) || 0)),
    priorPaymentsTotal: money(Math.max(0, Number(summary.priorPaymentsTotal) || 0)),
    grossInvoiceTotal: money(Math.max(0, Number(summary.grossInvoiceTotal) || 0)),
    balanceDue: money(Math.max(0, Number(summary.balanceDue) || 0)),
    source: summary.source || null,
    frozen: summary.frozen === true,
  };
};

export const shouldShowIssuedPaymentSummary = (invoice = {}) => {
  if (isDepositInvoiceRole(invoice)) return false;
  const role = getInvoiceRole(invoice) || 'full';
  return Boolean(invoice?.paymentSummary) && ['full', 'balance', 'balance-invoice'].includes(role);
};

export const resolveInvoiceDocumentPayableAmount = (invoice = {}, fallbackTotal = 0) => {
  const summary = getIssuedPaymentSummary(invoice);
  if (shouldShowIssuedPaymentSummary(invoice) && invoice?.paymentSummary) return summary.balanceDue;
  if (isDepositInvoiceRole(invoice)) return money(invoice?.amount);
  const role = getInvoiceRole(invoice);
  if (['balance', 'balance-invoice', 'partial', 'partial-invoice', 'progress', 'progress-invoice'].includes(role)) {
    return money(invoice?.amount);
  }
  return money(fallbackTotal || invoice?.amount);
};
